module.exports = __webpack_public_path__ + "img/platypus-logo.78b34078.png";